(function () {
    "use_strict";

    var $monthlyIncrease = $('input[name="monthly-increase"]');

    if ($monthlyIncrease.length > 0) {

        $monthlyIncrease.on('input change', function () {

            var $input = $(this);

            // Update bubble text
            $('#monthly-increase-value').text($input.val());

        });
    }

}());